import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { ISandwichSubscriptionPayload } from '@typings'
import { AxiosResponse } from 'axios'

export class PublicFormsApi extends AxiosBaseApi {
  submit_sandwich_subscription = (data: ISandwichSubscriptionPayload) =>
    this.api
      .post<AxiosResponse>(
        ENDPOINTS.PUBLIC_FORMS.SANDWICH_SUBSCRIPTION(),
        data
      )
      .then(response => response.data)
}
